<template>
  <div class="blackbody-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>E = hν (普朗克能量子)$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 渲染区：辐射强度曲线 -->
      <div class="canvas-mixed simulation">
         <svg width="100%" height="240" viewBox="0 0 400 240">
            <!-- 坐标轴 -->
            <line x1="50" y1="200" x2="350" y2="200" stroke="#888" />
            <line x1="50" y1="200" x2="50" y2="50" stroke="#888" />
            
            <!-- 经典电磁理论曲线 (紫外灾难) -->
            <path :d="classicPath" fill="none" stroke="#ff4757" stroke-dasharray="4,2" />
            <text x="300" y="80" fill="#ff4757" font-size="9">经典理论 (紫外灾难)</text>

            <!-- 普朗克公式曲线 -->
            <path :d="planckPath" fill="none" stroke="#ffd700" stroke-width="2.5" />
            <text x="180" y="100" fill="#ffd700" font-size="10">普朗克波谱</text>
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>黑体温度 T</label>
               <span class="val" :style="{ color: getColor }">{{ temperature }} K</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <label>调节温度 (维恩位移定律): {{ temperature }}K</label>
               <el-slider v-model="temperature" :min="3000" :max="8000" size="mini"></el-slider>
            </div>
         </div>

         <div class="theory-box">
            <p><strong>普朗克假说：</strong>为了解决“紫外灾难”，普朗克提出能量不是连续的，而是分成一份份的<strong>能量子</strong>。这是量子物理的开端。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlackbodyViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      temperature: 5500
    }
  },
  computed: {
    getColor() {
       const ratio = (this.temperature - 3000) / 5000;
       return `rgb(255, ${Math.floor(200 + ratio*55)}, ${Math.floor(100 + ratio*155)})`;
    },
    planckPath() {
       let d = "M 50 200";
       const T = this.temperature;
       // Simplified Planck: I = (1/L^5) / (exp(c/LT) - 1)
       for(let x=1; x<=300; x+=2) {
          const l = x * 0.5; // wavelength proxy
          const intensity = (Math.pow(T, 5) * 0.000000005) * Math.pow(l, 3) * Math.exp(-l/(T/1000));
          const y = 200 - intensity * 0.8;
          d += ` L ${50+x} ${Math.max(50, y)}`;
       }
       return d;
    },
    classicPath() {
       let d = "M 50 200";
       // Rayleigh-Jeans: I proportional to T/L^4
       for(let x=20; x<=100; x+=5) {
          const y = 200 - (1000 / x);
          d += ` L ${50+x} ${y}`;
       }
       return d;
    }
  }
}
</script>

<style scoped lang="scss">
.blackbody-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-mixed { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; right: 15px; .val { font-family: monospace; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } }
.theory-box { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
